module.exports = __webpack_public_path__ + "static/media/nhs.763e271c.png";